module.exports = __webpack_public_path__ + "img/walfare.917080a1.png";